import Vue, { DirectiveFunction, DirectiveOptions } from 'vue';
import VueGates from 'vue-gates';

Vue.directive('permission', VueGates as DirectiveOptions | DirectiveFunction);
Vue.directive('role', VueGates as DirectiveOptions | DirectiveFunction);
Vue.use(VueGates, { superRole: 'isAdmin' });
